/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { tagName } from "@ember-decorators/component";
import CategoriesOnly from "discourse/components/categories-only";
import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";

@tagName("")
export default class CategoriesWithFeaturedTopics extends Component {
  <template>
    <PluginOutlet
      @name="categories-with-featured-topics-wrapper"
      @outletArgs={{lazyHash categories=this.categories}}
    >
      <div ...attributes>
        <CategoriesOnly @categories={{this.categories}} @showTopics="true" />
      </div>
    </PluginOutlet>
  </template>
}
